const prefix = "EXCEPTION_LOG_";

export const CONNECTIVITY = prefix + "CONNECTIVITY";
export const EXPORT = prefix + "EXPORT";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const STATS_BY_MONTH = prefix + "STATS_BY_MONTH";
export const STATS_FOR_WEEK = prefix + "STATS_FOR_WEEK";
export const THROW_EXCEPTION = prefix + "THROW_EXCEPTION";
export const VIEW = prefix + "VIEW";
